import {objectFromEntries} from '@benchling/js-utils';
import {useMemo} from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';

/**
 * Extracts the pinned procedure flowchart version ID from a pinned procedure flowchart version object.
 */
export function getPinnedProcedureFlowchartVersionId(
  pinnedProcedureFlowchartVersion: null | {id?: string; __typename?: string}
): string | null {
  return pinnedProcedureFlowchartVersion != null &&
    !isInaccessible(pinnedProcedureFlowchartVersion) &&
    pinnedProcedureFlowchartVersion.id != null
    ? pinnedProcedureFlowchartVersion.id
    : null;
}

interface SampleTestPlanWithPinnedProcedureFlowchartVersion {
  procedureId: string;
  pinnedProcedureFlowchartVersionId: string;
}

export function usePinnedProcedureFlowchartVersionIdsByProcedureId(
  sampleTestPlans: Array<{
    procedureId: string;
    pinnedProcedureFlowchartVersionId: string | null;
  }>
): Record<string, string> {
  return useMemo(
    () =>
      objectFromEntries(
        sampleTestPlans
          .filter(
            (sampleTestPlan): sampleTestPlan is SampleTestPlanWithPinnedProcedureFlowchartVersion =>
              sampleTestPlan.pinnedProcedureFlowchartVersionId != null
          )
          .map((sampleTestPlan) => [
            sampleTestPlan.procedureId,
            sampleTestPlan.pinnedProcedureFlowchartVersionId,
          ])
      ),
    [sampleTestPlans]
  );
}
